import axios from 'axios';
import {store} from '../../store/configureStore';

const webhookUrl = 'https://hooks.slack.com/services/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';

export const logToSlack = async callData => {
  try {
    const storeSnapshot = store.getState();
    const {
      nextStep: {nextStep: currentStep},
      regType: {regType},
      router: {location: {pathname: path}}
    } = storeSnapshot;
    const data = {...callData,
      currentStep,
      regType,
      path
    };
    //if don't not replace " with ' - slack api returns "invalid_payload" error
    const text = JSON.stringify(data, null, '\t').replaceAll('"', "'");
    const payload = `{channel: "#test123", username: "webhookbot", text: "${text}", icon_emoji: ":ghost:"}`;
    const res = await axios.post(webhookUrl, payload, {
      transformRequest: [(data, headers) => {
        delete headers.post["Content-Type"];
        return data
      }]
    });
    if (res.status === 200) {
      console.log("Message Sent!");
    }
  } catch (logToSlackError) {
    console.error({logToSlackError})
  }
};


